import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取推荐上下车地点详情
 * @param data
 *
 */
export const getRecommendDetail = (data) => {
  return request({
    url: env.ferryUrl + '/recommend-location/detail',
    method: 'GET',
    params: data
  })
}

/**
 * 更改状态
 */
export const changeStatus = (data) => {
  return request({
    url: env.ferryUrl + '/recommend-location/changeStatus',
    method: 'GET',
    params: data
  })
}

/**
 * 获取用户信息
 */
export const getUserInfo = (data) => {
  return request({
    url: env.ferryUrl + '/common/user/intro',
    method: 'GET',
    params: data
  })
}
